import React from 'react'

import { Map } from '../../../../../app/maps/components/Map'
import { MAP_SUBTYPE_DAY_PERF, MAP_TYPE_ETF_HOLDINGS_WIDGET } from '../../../../../app/maps/constants/constants'
import { SettingsScreener, SettingsScreenerDark } from '../../../../../app/maps/constants/settings'
import { onNodeClick } from '../../../../../app/maps/utils'
import { ETFHoldingsBreakdownResponse } from '../types'
import { getBreakdownMapData } from '../utils'

interface IBreakdownProps {
  type: string
  data: ETFHoldingsBreakdownResponse
  dataTimestamp: number
}

export function BreakdownMap({ type, data, dataTimestamp }: IBreakdownProps) {
  const mapData = React.useMemo(() => getBreakdownMapData(data), [data])

  return (
    <div className="flex grow px-2 pb-2" data-testid={`etf-holdings-${type}`}>
      <Map
        className="flex-1 overflow-hidden"
        isFetchingPerf={false}
        isLoadingData={false}
        data={mapData.data}
        dataHash={dataTimestamp.toString()}
        type={MAP_TYPE_ETF_HOLDINGS_WIDGET}
        subtype={MAP_SUBTYPE_DAY_PERF}
        settings={FinvizSettings.hasDarkTheme ? SettingsScreenerDark : SettingsScreener}
        onNodeClick={(nodeProps) => {
          if (!nodeProps.node?.data?.data?.ticker) return
          onNodeClick(nodeProps)
        }}
        legend={false}
        zoom={false}
        truncateNodeName
      />
    </div>
  )
}
